export const volumes = [
  {
    number: 1,
    title: 'Strength & Stability Foundations',
    tagline: 'Build a stronger base',
    sessions: '61 sessions',
    months: 'Months 1–2',
    desc: 'Build solid foundations and structural strength in your clients from day one.',
    bar: 'bg-blue-500',
    text: 'text-blue-400',
    border: 'border-t-blue-500',
  },
  {
    number: 2,
    title: 'Power & Functional Transfer',
    tagline: 'Turn strength into power',
    sessions: '61 sessions',
    months: 'Months 3–4',
    desc: 'Develop speed, explosiveness and direct transfer to real athletic movements.',
    bar: 'bg-green-500',
    text: 'text-green-400',
    border: 'border-t-green-500',
  },
  {
    number: 3,
    title: 'Metabolic Endurance & Fat Loss',
    tagline: 'Build endurance. Burn more.',
    sessions: '61 sessions',
    months: 'Months 5–6',
    desc: "Burn fat and push your group's metabolic conditioning to the limit.",
    bar: 'bg-yellow-400',
    text: 'text-yellow-300',
    border: 'border-t-yellow-400',
  },
  {
    number: 4,
    title: 'Functional Hypertrophy',
    tagline: 'More muscle. More function.',
    sessions: '61 sessions',
    months: 'Months 7–8',
    desc: 'Build muscle the functional way with hypertrophy protocols adapted for group training.',
    bar: 'bg-purple-500',
    text: 'text-purple-400',
    border: 'border-t-purple-500',
  },
  {
    number: 5,
    title: 'Agility & Athletic Performance',
    tagline: 'Move faster. Go further.',
    sessions: '61 sessions',
    months: 'Months 9–10',
    desc: 'Improve coordination, agility and overall athletic capacity at any level.',
    bar: 'bg-cyan-500',
    text: 'text-cyan-400',
    border: 'border-t-cyan-500',
  },
  {
    number: 6,
    title: 'Specialization & Final Challenges',
    tagline: 'Integrate. Perform. Complete.',
    sessions: '60 sessions',
    months: 'Months 11–12',
    desc: 'Put the whole year to the test with challenges and competitive benchmarks.',
    bar: 'bg-red-500',
    text: 'text-red-400',
    border: 'border-t-red-500',
  },
]

export const sessionFeatures = [
  { title: 'Daily objective', desc: "So you know exactly where you're headed" },
  { title: 'Ready-made warm-up', desc: 'No more improvised warm-ups' },
  { title: '3 versions: A/B/C', desc: 'Mixed group or separate groups — it works either way' },
  { title: 'Sets, reps & timing', desc: 'Fully specified — nothing vague' },
  { title: 'Professional cool-down', desc: 'End every class with structure' },
  { title: "Coach's Tip", desc: "New to coaching? You learn. Already a pro? You validate." },
  { title: 'One session per page', desc: 'Open it, teach it, done' },
]

export const featureChips = [
  'Gym + Boxing + Functional',
  'Full-year program',
  'A/B/C versions by level',
  'Warm-ups & cool-downs',
  '365 ready sessions',
  'Basic equipment only',
]
